<template>
  <div class="flex-grow-1">
    <div class="form-label d-inline-flex">
      {{ title }}
      <IconButton
        icon-name="material-symbols:add"
        class="ms-1 text-success"
        @keypress.stop
        @click.stop="$emit('create')"
      />
    </div>
    <div class="add-on-table-container border rounded flex-grow-1">
      <CheckboxTable
        v-if="linkTable"
        :loading="loading"
        :loading-row-id="loadingRowId"
        :loading-col-key="loadingColKey"
        :items="items"
        :cols-map="colsMap"
        class="m-0 shadow-none"
        @delete="(id: number) => $emit('delete', id)"
        @update="(id: number) => $emit('update', id)"
        @checked="(id: number, key: string, value: boolean) => $emit('checked', id, key, value)"
      />
      <ProductCatalogueTable
        v-else
        :loading="loading"
        :items="items"
        :cols-map="colsMap"
        class="m-0 shadow-none"
        @delete="(id: number) => $emit('delete', id)"
        @update="(id: number) => $emit('update', id)"
      />
    </div>
  </div>
</template>
<script lang="ts" setup>
interface Props {
  title: string;
  items: {[key: string]: any}[];
  loading?: boolean;
  loadingRowId?: number;
  loadingColKey?: string;
  colsMap: {[key: string]: string};
  linkTable?: boolean;
}

withDefaults(defineProps<Props>(), {
  loading: false,
  loadingRowId: undefined,
  loadingColKey: undefined,
  linkTable: false,
});

defineEmits<{
  create: [];
  update: [id: number];
  delete: [id: number];
  checked: [id: number, key: string, value: boolean];
}>();
</script>
<style lang="scss" scoped>
.add-on-table-container {
  border-color: var(--bs-input-border-color);
}
</style>
